import React, { Component } from 'react';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import JournalEntriesListPageUI from './JournalEntriesListPageUI';
import { withRouter } from 'react-router-dom';

class JournalEntriesListPageSF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorList: null,
            journalId: null,
            journalDTOList: []
        }
    }

    render() {
        return (
            <JournalEntriesListPageUI
                context={this.props.context}
                errorList={this.state.errorList}
                journalId={this.state.journalId}
                journalDTOList={this.state.journalDTOList}
                onPushClick={this.onPushClick}
                onRefreshClick={this.onRefreshClick}
            />
        );
    }

    componentDidMount() {
        let context = this.props.context
        this.getJournalEntries(context)
    }

    getJournalEntries(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${this.props.match.params.accountId}/journals`,
            cacheKey: CacheKeys.JournalEntries(this.props.match.params.accountId),
            callback: this.getJournalEntriesCallback,
            ttlInSecs: 3600
        });
        cacheManager.getObject2(context);
    }

    getJournalEntriesCallback = (response) => {
        this.setState({
            errorList: response.errorList,
            journalDTOList: response.journalDTOList
        })
    }

    onPushClick = (event) => {
        let selectedJournalId = event.currentTarget.getAttribute('data-journal-id')
        this.setState({ journalId: selectedJournalId })

        RestApiUtils.post(this.props.context, `/api/su/accounts/${this.props.match.params.accountId}/journals/${selectedJournalId}/zybra`,
            this.onPushClickCallback, null, null
        )
    }

    onPushClickCallback = (response) => {
        this.setState({ errorList: response.errorList })
    }

    onRefreshClick = () => {
        CacheManager.removeObject(CacheKeys.JournalEntries(this.props.match.params.accountId));
        this.setState({ errorList: null, journalDTOList: null });
        this.getJournalEntries(this.props.context);
    }
}

export default withRouter(JournalEntriesListPageSF)